module.exports = __webpack_public_path__ + "img/sharp-id-example.87ade7ce.jpg";